import React from 'react'

const MoflipLogo = ({ color = 'default', size = 'h-[120px] w-[160px]' }) => {
  return <img src={'/logo.png'} className={`${size}`} />
}

export default MoflipLogo
